import { render, staticRenderFns } from "./DetailsManuShop.vue?vue&type=template&id=3f2ca91e&scoped=true"
import script from "./DetailsManuShop.vue?vue&type=script&lang=js"
export * from "./DetailsManuShop.vue?vue&type=script&lang=js"
import style0 from "./DetailsManuShop.vue?vue&type=style&index=0&id=3f2ca91e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2ca91e",
  null
  
)

export default component.exports